import { EJSON } from 'meteor/ejson';

export const setLocalStorage = (key: string, value: any, opts?: { ttl?: number }) => {
  const ttl = opts?.ttl;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    localStorage.setItem(key, JSON.stringify(value));
  }
  else {
    localStorage.setItem(key, EJSON.stringify({ ...value, __expireAt: ttl ? Date.now() + ttl : undefined }));
  }
};

export const getLocalStorage = (key: string) => {
  const rawItem = localStorage.getItem(key);
  if (!rawItem) return null;
  try {
    const value = JSON.parse(rawItem);
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value;
    const ejsonValue = EJSON.parse(rawItem);
    const expireAt = parseInt(ejsonValue.__expireAt as string || '0');
    if (expireAt && Date.now() > expireAt) { removeLocalStorage(key); return null; }
    return ejsonValue;
  }
  catch (_) {
    return rawItem;
  }
};

export const removeLocalStorage = (key: string) => localStorage.removeItem(key);